import React from "react";

import cx from "classnames";

import styles from "./ModalVerticalSpace.scss";

export interface ModalVerticalSpaceProps {
  className?: string;
}

/**
 * To standardize vertical space between modal elements, use this element. It
 * takes few props and exists only to standardize vertical spacing between
 * elements you want on your modal.
 */
export function ModalVerticalSpace({ className }: ModalVerticalSpaceProps) {
  return <div className={cx(styles["modal-vertical-space"], className)} />;
}
